import { render, staticRenderFns } from "./CXCompetitorSettings.vue?vue&type=template&id=48b4fb62&scoped=true&"
import script from "./CXCompetitorSettings.vue?vue&type=script&lang=js&"
export * from "./CXCompetitorSettings.vue?vue&type=script&lang=js&"
import style0 from "./CXCompetitorSettings.vue?vue&type=style&index=0&id=48b4fb62&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48b4fb62",
  null
  
)

export default component.exports